<template>
    <div class="co-filtros-components-gerador-documento">
        <span>Gerador {{ $tc("pt_br.documento").toLowerCase() }}</span>

        <v-select
            v-model="value.autorDocumento.value"
            class="pt-0 mt-0"
            placeholder="Buscar"
            persistent-placeholder
            :items="autores"
            :disabled="disabled"
            item-text="email"
            item-value="email"
        />
    </div>
</template>

<script>
import {actionTypes} from '@/commons/constants'
import {mapState} from 'vuex'

export default {
    name: 'FiltroAutor',
    props: {
        value: {
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['login']),
        ehOrganizacaoCriada() {
            return this.login.organizacaoPlano.organizacaoExistente
        },
    },
    watch: {
        async ehOrganizacaoCriada(value) {
            if (value) {
                await this.buscarUsuariosOrganizacao()
            }
        }
    },
    async created() {
        await this.buscarUsuariosOrganizacao()
    },
    data() {
        return {
            autores: []
        }
    },
    methods: {
        async buscarUsuariosOrganizacao() {
            if (!this.ehOrganizacaoCriada) return
           this.autores = await this.$store.dispatch(actionTypes.ORGANIZACAO.BUSCAR_TODOS_USUARIOS_ORGANIZACAO)
        }
    }
}
</script>

<style lang="stylus">
.co-filtros-components-gerador-documento
    width 100%
</style>